// extracted by mini-css-extract-plugin
module.exports = {"TicketCount":"TicketCount_TicketCount__JKusA","TicketCount__Emphasis":"TicketCount_TicketCount__Emphasis__cm1Nf"};